import { render, staticRenderFns } from "./FullscreenModeDialog.vue?vue&type=template&id=97740e04&scoped=true&"
import script from "./FullscreenModeDialog.vue?vue&type=script&lang=ts&"
export * from "./FullscreenModeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FullscreenModeDialog.vue?vue&type=style&index=0&id=97740e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97740e04",
  null
  
)

export default component.exports